export default __webpack_public_path__ + "static/media/mode-2004.9db694fb.svg";